<template>
  <v-card elevation="0" class="ma-0 pa-0" width="100%">
    <v-row class="ma-0 pa-0">
      <v-col cols="12" class="ma-0 pa-0">
        <v-icon color="normalred">mdi-package-variant</v-icon>
        <span class="step-title">Cadastro de tamanho de embalagens</span>
        <br/>
      </v-col>
    </v-row>

    <v-form
        v-for="(packaging, index) in shippingPackaging"
        :key="packaging.skuLength"
        class="form"
        :ref="packaging.form"
        lazy-validation
    >
      <v-row cols="12">
        <v-col class="mb-2 pb-0" cols="12">
          <h3>Dimensões da embalagem para o produto com o SKU da Largura: {{ packaging.skuLength }} centímetros</h3>
        </v-col>
      </v-row>

      <v-row class="mb-0 pb-0 mb-3" cols="12">
        <v-col align-self="end" cols="12" xs="12" sm="12" md="4" lg="2" xl="2">
          <label class="pb-3">
            <strong>Altura (Em cm)</strong>
            <strong class="required">*</strong>
          </label>
          <v-text-field
              dense
              outlined
              required
              v-model="packaging.height"
              placeholder="Ex: 10"
              class="mt-1"
              color="primary"
              style="border-radius: 5px!important; height: 35px!important;              "
              v-mask="'###'"
              hide-details
          ></v-text-field>
        </v-col>

        <v-col align-self="end" cols="12" xs="12" sm="12" md="4" lg="2" xl="2">
          <label class="pb-3">
            <strong>Largura (Em cm)</strong>
            <strong class="required">*</strong>
          </label>
          <v-text-field
              dense
              outlined
              :rules="[rules.required]"
              v-model="packaging.width"
              color="primary"
              placeholder="Ex: 10"
              class="mt-1"
              required
              v-mask="'###'"
              hide-details
              style="border-radius: 5px!important; height: 35px!important; "
          ></v-text-field>
        </v-col>

        <v-col align-self="end" cols="12" xs="12" sm="12" md="4" lg="2" xl="2">
          <label class="pb-3">
            <strong>Comprimento (Em cm)</strong>
            <strong class="required">*</strong>
          </label>
          <v-text-field
              dense
              outlined
              :rules="[rules.required]"
              v-model="packaging.length"
              color="primary"
              placeholder="Ex: 124"
              class="mt-1"
              required
              v-mask="'###'"
              style="border-radius: 5px!important; height: 35px!important; "
              hide-details
          ></v-text-field>
        </v-col>

        <v-col align-self="end" cols="12" xs="12" sm="12" md="4" lg="2" xl="2">
          <label class="pb-3">
            <strong>Peso (Em Kg)</strong>
            <strong class="required">*</strong>
          </label>
          <v-text-field
              dense
              outlined
              :rules="[rules.required]"
              v-model="packaging.weight"
              color="primary"
              placeholder="Ex: 1,2"
              class="mt-1"
              style="border-radius: 5px!important; height: 35px!important; "
              required
              type="number"
              hide-details
          ></v-text-field>
        </v-col>

        <v-col align-self="end" cols="12" xs="12" sm="12" md="4" lg="3" xl="3">
          <label class="pb-3">
            <strong>Quantidade máxima por embalagem (Em metros)</strong>
            <strong class="required">*</strong>
          </label>
          <v-text-field
              dense
              outlined
              :rules="[rules.required]"
              v-model="packaging.maximumQuantityMetersPerPackage"
              color="primary"
              placeholder="Ex: 25,5"
              class="mt-1"
              style="border-radius: 5px!important; height: 35px!important; "
              required
              type="number"
              hide-details
          ></v-text-field>
        </v-col>

        <v-col align-self="end" cols="12" xs="12" sm="12" md="4" lg="1" xl="1">
          <div>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    outlined
                    fab
                    tile
                    style="border-radius: 6px"
                    small
                    @click="submit(packaging)"
                    color="#bc0000"
                    class="remove-button"
                    v-bind="attrs"
                    v-on="on"
                >
                  <v-icon dark>mdi-content-save-edit</v-icon>
                </v-btn>
              </template>
              <span>Savar</span>
            </v-tooltip>
          </div>
        </v-col>

        <v-col cols="12" v-if="index < shippingPackaging.length - 1">
          <hr/>
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import Vue from "vue";

export default {
  name: "ShippingPackaging",
  components: {},
  props: {},
  data: () => ({
    typeManually: false,
    naoLocalizado: false,
    hasAddressNumber: true,
    loading: true,
    shippingPackagingAdded: [],
    shippingPackaging: [],
    currentUser: {
      image: "",
      Name: "",
      defaultFrete: "",
      agreement: false,
      cnpj: "",
      inscrEstadual: "",
      phoneNumber: "",
      phoneNumber2: "",
      birthDate: "",
      postalCode: "",
      state: "",
      city: "",
      neighborhood: "",
      addressName: "",
      addressNumber: "",
      country: "",
      addressComplement: "",
      resaleRegion: "",
      category: "",
      region: "",
      password: "",
      password2: "",
      email: "",
      email2: "",
      resaleWebSite: "",
      receiveEmail: "",
      receiveSms: "",
      textObservation: "",
      tokenMelhorEnvio: "",
      latitude: null,
      longitude: null,
    },
    apiService: new ApiService(),
    user: {},
    dialog: false,
    userTypeMaster: 0,
    userTypeAdmin: 1,
    userTypeResale: 2,
    userTypeInstaller: 3,
    specialties: [],
    isEditing: false,
    rules: {
      nameRules: (v) => (v && v.length <= 128) || "Nome deve ter no máximo 128 caracteres",
      required: (value) => !!value || "Campo requerido.",
      min: (v) => v.length >= 4 || "Minimo de 4 caracteres.",
      postalCodeRules: (v) => (v && v.length <= 10) || "CEP deve ter no máximo 10 caracteres",
    },
    estados: [
      "AC",
      "AL",
      "AM",
      "AP",
      "BA",
      "CE",
      "DF",
      "ES",
      "GO",
      "MA",
      "MT",
      "MS",
      "MG",
      "PA",
      "PB",
      "PR",
      "PE",
      "PI",
      "RJ",
      "RN",
      "RO",
      "RS",
      "RR",
      "SC",
      "SE",
      "SP",
      "TO",
    ],
  }),
  async created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    await this.getShippingPackaging()
  },
  methods: {
    async getShippingPackaging() {
      try {
        await this.apiService
            .get(`shippingPackaging/list/${this.user.id}`)
            .then((response) => {
              this.shippingPackagingAdded = response
              this.shippingPackaging = [];
              this.resetShippingPackaging()
              if (this.shippingPackagingAdded && this.shippingPackagingAdded.length > 0) {
                this.shippingPackaging.forEach((shipping, index) => {
                  const shippingPackagingAdded = this.shippingPackagingAdded.find((x) => x.skuLength == shipping.skuLength)
                  if (shippingPackagingAdded && shippingPackagingAdded.id) {
                    shipping.id = shippingPackagingAdded.id
                    shipping.width = shippingPackagingAdded.width
                    shipping.height = shippingPackagingAdded.height
                    shipping.length = shippingPackagingAdded.length
                    shipping.weight = shippingPackagingAdded.weight.toFixed(2)
                    shipping.maximumQuantityMetersPerPackage = shippingPackagingAdded.maximumQuantityMetersPerPackage.toFixed(2)
                  }
                })
              }
            });
      } catch (e) {

      }
    },
    resetShippingPackaging() {
      this.shippingPackaging = [
        {
          id: null,
          resaleId: null,
          width: null,
          height: null,
          length: null,
          weight: null,
          skuLength: 140,
          maximumQuantityMetersPerPackage: null,
        },
        {
          id: null,
          resaleId: null,
          width: null,
          height: null,
          length: null,
          weight: null,
          skuLength: 122,
          maximumQuantityMetersPerPackage: null,
        },
        {
          id: null,
          resaleId: null,
          width: null,
          height: null,
          length: null,
          weight: null,
          skuLength: 106,
          maximumQuantityMetersPerPackage: null,
        },
        {
          id: null,
          resaleId: null,
          width: null,
          height: null,
          length: null,
          weight: null,
          skuLength: 100,
          maximumQuantityMetersPerPackage: null,
        },
        {
          id: null,
          resaleId: null,
          width: null,
          height: null,
          length: null,
          weight: null,
          skuLength: 70,
          maximumQuantityMetersPerPackage: null,
        },
        {
          id: null,
          resaleId: null,
          width: null,
          height: null,
          length: null,
          weight: null,
          skuLength: 61,
          maximumQuantityMetersPerPackage: null,
        },
        {
          id: null,
          resaleId: null,
          width: null,
          height: null,
          length: null,
          weight: null,
          skuLength: 53,
          maximumQuantityMetersPerPackage: null,
        },
        {
          id: null,
          resaleId: null,
          width: null,
          height: null,
          length: null,
          weight: null,
          skuLength: 50,
          maximumQuantityMetersPerPackage: null,
        },
      ]
    },
    async submit(packaging) {
      try {
        if (packaging.width && Number(packaging.width) > 0 &&
            packaging.height && Number(packaging.height) > 0 &&
            packaging.length && Number(packaging.length) > 0 &&
            packaging.weight && Number(packaging.weight) > 0 &&
            packaging.maximumQuantityMetersPerPackage && Number(packaging.maximumQuantityMetersPerPackage) > 0
        ) {
          packaging.resaleId = this.user.id;
          packaging.width = Number(packaging.width).toFixed(2).toString().replace(",", ".");
          packaging.height = Number(packaging.height).toFixed(2).toString().replace(",", ".");
          packaging.length = Number(packaging.length).toFixed(2).toString().replace(",", ".");
          packaging.weight = Number(packaging.weight).toFixed(2).toString().replace(",", ".");
          packaging.maximumQuantityMetersPerPackage = Number(packaging.maximumQuantityMetersPerPackage).toFixed(2).toString().replace(",", ".");
          if (packaging.id) {
            await this.apiService
                .put(`shippingPackaging/${packaging.id}`, packaging)
                .then(async (response) => {
                  this.$toast.success("Salvo com sucesso");
                  this.shippingPackagingAdded = []
                  this.shippingPackaging = [];
                  await this.getShippingPackaging()
                });
          } else {
            delete packaging.id
            await this.apiService
                .post(`shippingPackaging`, packaging)
                .then(async (response) => {
                  this.$toast.success("Salvo com sucesso");
                  this.shippingPackagingAdded = []
                  this.shippingPackaging = [];
                  await this.getShippingPackaging()
                });
          }
          return
        }
        this.$toast.error("Preenha todos os campos corretamente");
      } catch (e) {
        console.error(e)
      }
    },
  },
};
</script>
<style scoped>
.required {
  color: #bc0000
}

.remove-button {
  border: 2px solid #bc0000;
  border-radius: 4px;
}

.remove-button:hover {
  background: #bc0000;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  color: white !important;
}
</style>
